<template>
  <el-container class="ys-page">
    <div class="ys-wrapper ys-report-wrapper">
      <div class="ys-search-box">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item label="商品" class="keyWords-box">
            <el-input v-model="params.keyWords" placeholder="请输入商品名称、助记码、商品编码、条码" @keyup.enter.native="queryProduct()" clearable></el-input>
          </el-form-item>
          <el-checkbox v-model="params.filterInvItem" style="margin-top: 4px;" true-label="Y" false-label="N" label="只显示有库存商品" />
        </el-form>
        <div>
          <el-button type="primary" @click="queryProduct()">查询</el-button>
        </div>
      </div>
      <div class="content-box">
        <div class="categorize-box">
          <div class="title-box">商品类别</div>
          <el-tree :data="categoryData" :default-expanded-keys="defaultExpanded" :props="defaultProps" node-key="value" :expand-on-click-node="false" highlight-current @node-click="handleNodeClick"></el-tree>
        </div>
        <div class="table-box" v-loading="tableIsLoading">
          <el-table
            ref="table"
            :row-key="getRowKey"
            :data="tableData"
            size="mini"
            border
            stripe
            height="100%"
            max-height="100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column
              type="selection"
              width="50"
              reserve-selection
              :selectable="selectable"
            ></el-table-column>
            <el-table-column label="商品名称" prop="text"></el-table-column>
            <el-table-column label="规格" prop="itemSpec"></el-table-column>
            <el-table-column label="库存数" prop="onhandQtyQtyFormat"></el-table-column>
            <el-table-column label="可用数" prop="availableQtyFormat"></el-table-column>
            <el-table-column v-if="$store.state.power.isEnableProductDate == 'Y'" label="生产日期" prop="productionDate"></el-table-column>
          </el-table>
        </div>
      </div>
      <div class="footer">
        <div style="display: flex; align-items: center;">
          <span>共<span style="font-weight: 500;font-size: 16px;color: #4075e6;margin: 0 4px;">{{ productTotal }}</span>条</span>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="params.current"
            :page-sizes="[30, 50, 100, 200]"
            :page-size="params.size"
            layout="sizes, prev, pager, next"
            :total="productTotal"
          >
          </el-pagination>
        </div>
        <div style="margin-top: 12px;">
          <el-button size="small" @click="colse">取消</el-button>
          <el-button type="primary" @click="postProductMessage()">确定</el-button>
        </div>
      </div>
    </div>
  </el-container>
</template>

<script>
export default {
  props: {
    args: {
      type: Object,
      default: () => { return {} }
    },
    defaultCheckedKeys: {
      type: Array,
      default: () => []
    },
    defaultDisabledKeys: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      params: {
        filterInvItem: 'N',
        keyWords: '',
        size: 50,
        current: 1,
        billType: 'PKD',
        firstType: '',
        firstValue: '',
        secondType: '',
        secondValue: '',
        ...this.args
      },
      categoryData: [],
      defaultProps: {
        children: 'secondList',
        label: 'text'
      },
      defaultExpanded: [],
      tableIsLoading: false,
      tableData: [],
      productTotal: 0,
      selectProductList: []
    };
  },
  created() {
    this.getBrandData()
    this.getProductData()
    this.toggleRowSelection()
  },
  methods: {
    async getBrandData() {
      const { data: res } = await this.$post('/erpnew/account/c/reada46ceb/invCheck/selectItemTypeList', {
        billType: 'PKD',
        levelType: 3
      })
      if (res.code != "0") return this.$message.error(res.message);
      this.categoryData = res.data
      this.categoryData.forEach(first => {
        if (first.firstId == '-1') {
          this.defaultExpanded = [first.value]
        }
        first.secondList && first.secondList.forEach(second => {
          second.firstType = first.type
          second.secondList && second.secondList.forEach(third => {
            third.firstType = second.type
          })
        })
      })
    },
    async getProductData() {
      this.tableIsLoading = true;
      const { data: res } = await this.$post('/erpnew/account/c/reada46ceb/invCheck/selectItemList', this.params)
      this.tableIsLoading = false;
      if (res.code != "0") return this.$message.error(res.message);
      this.tableData = res.data.itemSearchList.map(i => {
        i['text'] = i.itemName
        i['value'] = i.itemID
        return i
      })
      this.productTotal = res.data.count
    },
    handleNodeClick(data) {
      if (data.currentdepth == null) {
        // 零级的
        this.params.firstValue = ''
        this.params.firstType = ''
        this.params.secondValue = ''
        this.params.secondType = ''
      } else if (data.currentdepth == 2) {
        // 一级的
        this.params.firstValue = data.value
        this.params.firstType = data.type
        this.params.secondValue = ''
        this.params.secondType = ''
      } else if (data.currentdepth == 3) {
        // 二级的
        this.params.firstValue = data.firstId
        this.params.firstType = data.firstType
        this.params.secondValue = data.value
        this.params.secondType = data.type
      }
      this.queryProduct()
    },
    handleSelectionChange(val) {
      this.selectProductList = val;
    },
    // 监听pagesize的改变
    handleSizeChange(newSize) {
      this.params.size = newSize;
      this.getProductData();
    },
    // 监听页码值的改变
    handleCurrentChange(newPage) {
      this.params.current = newPage;
      this.getProductData();
    },
    getRowKey(row) {
      return row.value + (row.productionDate ? row.productionDate : '');
    },
    colse() {
      this.$emit('close')
    },
    queryProduct() {
      this.params.current = 1;
      this.getProductData();
    },
    postProductMessage() {
      this.$emit('get-product-data', this.selectProductList)
    },
    toggleRowSelection() {
      this.defaultCheckedKeys.forEach(item => {
        this.$nextTick(() => {
          this.$refs.table.toggleRowSelection(item, true)
        })
      })
    },
    selectable(row) {
      return this.defaultDisabledKeys.findIndex(i => this.getRowKey(i) == this.getRowKey(row)) == -1
    }
  },
};
</script>

<style scoped lang="less">
.el-container {
  max-height: 800px;
  .ys-page {
    padding: 12px;
    .ys-wrapper {
      width: 100%;
      overflow: hidden;
      .ys-search-box {
        display: flex;
        justify-content: space-between;
      }
      .content-box {
        min-height: 200px;
        height: 56vh;
        margin-top: 12px;
        display: flex;
        .categorize-box {
          padding: 0 8px;
          width: 150px;
          box-sizing: border-box;
          .title-box {
            height: 38px;
            line-height: 38px;
            border-top: 1px solid #C4C4C4;
            border-bottom: 1px solid #c4c4c4;
            font-size: 14px;
            font-weight: 500;
            color: rgb(51, 51, 51)
          }
          .el-tree {
            height: calc(100% - 38px);
            overflow-y: auto;
            // padding-right: 6px;
          }
        }
        .table-box {
          width: calc(100% - 150px);
        }
      }
      .footer {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        margin-top: 12px;
        ::v-deep .el-pagination {
          text-align: right;
          .el-pager {
            li.active {
              color: #4075E6;
            }
            li {
              background: #f2f2f2;
            }
          }
          .el-pagination__sizes {
            .el-input__inner {
              border: none;
              background-color: #f2f2f2;
              border-radius: 218px;
              background: #f2f2f2;
              box-shadow: none;
              color: #666;
            }
          }
          .btn-prev {
            border-top-left-radius: 218px;
            border-bottom-left-radius: 218px;
            margin-left: 20px;
            background: #f2f2f2;
          }
          .btn-next {
            border-top-right-radius: 218px;
            border-bottom-right-radius: 218px;
            background: #f2f2f2;
          }
        }
      }
    }
  }
}
::v-deep .el-checkbox {
  .el-checkbox__input.is-indeterminate {
    .el-checkbox__inner {
      background-color: #4075E6;
      border-color: #4075E6;
    }
  }
  &.is-checked {
    .el-checkbox__label {
      color: #4075E6;
    }
    .el-checkbox__inner {
      background-color: #4075E6;
      border-color: #4075E6;
    }
  }
}
::v-deep .el-input__suffix {
  display: flex;
  align-items: center;
}

.categorize-box {
  ::-webkit-scrollbar {
      width: 6px;
      height: 10px;
      border-radius: 6px;
      background: rgba(0, 0, 0, 0.05);
  }
  ::-webkit-scrollbar-thumb {
      background-color: rgba(196, 196, 196, 1);
      border-radius: 6px;
  }
  .el-scrollbar__bar {
      &.is-horizontal {
          height: 10px;
      }
  }
}
</style>